var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"max-h-full",staticStyle:{"width":"100%"},attrs:{"src":require("../../assets/sberbank/img/bg-1.png"),"alt":"story_1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }